import {
  ADD_GOSFORMCLAIM,
  GET_ALLGOSFORMCLAIM,
  LOADING_GOSFORMCLAIM,
  STOP_LOADING_GOSFORMCLAIM,
  UPDATE_GOSFORMCLAIM,
  DELETE_GOSFORMCLAIM,
} from "../types";

const initialState = {
  gosFormClaims: [],
  total: 0,
  loading_state: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_GOSFORMCLAIM:
      // The list is refetched straight after a create, so row order and
      // pagination stay whatever the server says — nothing to merge here.
      return state;

    case GET_ALLGOSFORMCLAIM:
      return {
        ...state,
        gosFormClaims: action.payload.data,
        pendingGosFormClaims: action.payload.data.filter(
          (claim) => claim.status === 1,
        ),
        total: action.payload.total,
      };

    case LOADING_GOSFORMCLAIM:
      return {
        ...state,
        loading_state: true,
      };

    case STOP_LOADING_GOSFORMCLAIM:
      return {
        ...state,
        loading_state: false,
      };

    case UPDATE_GOSFORMCLAIM: {
      const index = state.gosFormClaims.findIndex(
        (x) => x.id === action.payload?.id,
      );
      if (index === -1) {
        return { ...state, loading_state: false };
      }
      const updatedGosFormClaims = [...state.gosFormClaims];
      updatedGosFormClaims[index] = {
        ...updatedGosFormClaims[index],
        ...action.payload,
      };
      return {
        ...state,
        gosFormClaims: updatedGosFormClaims,
        loading_state: false,
      };
    }

    case DELETE_GOSFORMCLAIM:
      return {
        ...state,
        gosFormClaims: state.gosFormClaims.filter(
          (claim) => claim.id !== action.payload,
        ),
      };

    default:
      return state;
  }
}
